import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const AppInfo = () => {
  const useStyles = makeStyles((theme) => ({
    root: {
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="body1">
        This <a href="https://reactjs.org/">React</a> demo app uses features
        such as{" "}
        <a href="https://www.npmjs.com/package/react-router-dom">routing</a>,{" "}
        <a href="https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API">
          local storage
        </a>
        , <a href="https://material-ui.com/">Material-UI</a>,{" "}
        <a href="https://jaredpalmer.com/formik/">Formik</a> (forms),{" "}
        <a href="https://github.com/jquense/yup">Yup</a> (form validation), and{" "}
        <a href="https://fontawesome.com/">Font Awesome</a> (icons). It uses a
        pure functional component model using React v16.
      </Typography>
    </div>
  );
};

AppInfo.propTypes = {};

export default AppInfo;
